import sortCarsAndMinivans from 'lib/util/sort.carsAndMinivans';
import sortCrossoversAndSuvs from 'lib/util/sort.crossoversAndSuvs';
import PageCache from '../page-cache';

var __defaultCategorySortOrder = ['cars-n-minivans', 'trucks', 'crossovers-n-suvs', 'hybrids-n-evs'];
// the list of cars that are also hybrids
var __carHybrids = ['corollahybrid', 'prius', 'camryhybrid', 'priusprime', 'avalonhybrid', 'mirai'];
// this list of crossovers/suvs that are also hybrids
var __crossoverAndSuvHybrids = ['rav4hybrid', 'highlanderhybrid'];

function categorizeSeries(allSeries) {
  var byCategory = {};
  var sorted = {};

  allSeries.forEach(function (series) {
    series.categories.forEach(function (cat) {
      if (!byCategory[cat.code]) {
        byCategory[cat.code] = {
          code: cat.code,
          name: cat.name,
          series: [],
        };
      }

      // All gets every series
      byCategory[cat.code].series.push(series);
    });
  });

  // Sort the categories on the object
  __defaultCategorySortOrder.forEach(function (catId) {
    if (byCategory[catId]) {
      sorted[catId] = byCategory[catId];
      delete byCategory[catId];
    }
  });

  // Catch anything we miss
  Object.keys(byCategory).forEach(function (catId) {
    sorted[catId] = byCategory[catId];
  });

  return sorted;
}

// get the list of hybrids and add the hybrids that are also cars to the array
// of cars and minivans, and then sort the list in the custom order they
// want (which currently should match Tcom)
function addHybridsToCarsAndMinivans(byCategory) {
  var seriesByCategory = Object.assign({}, byCategory);
  var hybrids = seriesByCategory['hybrids-n-evs'].series;
  var hybridsToAddToCarsAndMinivans = hybrids.filter(function (hybridSeries) {
    return __carHybrids.indexOf(hybridSeries.series_code) > -1;
  });
  var mergedArray = seriesByCategory['cars-n-minivans'].series.concat(hybridsToAddToCarsAndMinivans);
  sortCarsAndMinivans(mergedArray);
  seriesByCategory['cars-n-minivans'].series = mergedArray;
  return seriesByCategory;
}

// get the list of hybrids (after they are parsed out by category) and add the two crossover/suv
// vehicles that are also hybrids to the crossvers-suvs array, then sort the merged list based
// on the custom order they want
function addHybridsToCrossovers(byCategory) {
  var seriesByCategory = Object.assign({}, byCategory);
  var hybrids = seriesByCategory['hybrids-n-evs'].series;
  var hybridsToAddToCrossoversAndSuvs = hybrids.filter(function (hybridSeries) {
    return __crossoverAndSuvHybrids.indexOf(hybridSeries.series_code) > -1;
  });
  var mergedArray = seriesByCategory['crossovers-n-suvs'].series.concat(hybridsToAddToCrossoversAndSuvs);
  sortCrossoversAndSuvs(mergedArray);
  seriesByCategory['crossovers-n-suvs'].series = mergedArray;
  return seriesByCategory;
}

PageCache.await('series.raw').then(function (data) {
  var allSeries = data.seriesDepthOne.series;
  var byCategory = categorizeSeries(allSeries);
  PageCache.set('series.byCategory.all', byCategory);
  return byCategory;
});

PageCache.await('series.latest').then(function (data) {
  // series.latest is already processed by another transform so it doesn't
  // contain any of the extras.
  var byCategory = categorizeSeries(data);
  PageCache.set('series.byCategory.merged.hybrids', byCategory);
  var byCategoryWithHybridsMerged = addHybridsToCarsAndMinivans(byCategory);
  byCategoryWithHybridsMerged = addHybridsToCrossovers(byCategoryWithHybridsMerged);
  return byCategoryWithHybridsMerged;
});
